import React, { Component } from 'react';
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary';
import Button from '../../UI/Button/Button';
//import {Route} from 'react-router-dom';
//import classes from '../../UI/Button/button.module.css';

//Lecture 153 -change from func based to Class based to add Lifecycle hook
//changing this to a class had negligible performance but Modal did effect the
//componentDidUpdate rerendering

class OrderSummary extends Component {
    componentDidUpdate() {
       //removing this killed conn.!!
    }
    
    render () {
        const ingredientSummary = Object.keys(this.props.ingredients)
        .map(igKey => {
            return (<li key={igKey}><span style={{textTransform: 'capitalize'}}>{igKey}</span>: 
             {this.props.ingredients[igKey]}
             </li>);
        });

        return (
            //return JSX code here
            <Auxiliary> 
            <h3>Your Order!</h3>
            <p> A delicious burger with the following items:</p>
            <ul>
                 {ingredientSummary} 
             </ul>
    <p><strong>Total Price: ${this.props.price.toFixed(2)} </strong></p>
             <p> Continue to Checkout?</p>
             <Button btnType="Danger" clicked={this.props.purchCanceled}> CANCEL</Button>
              {/* <Route to="/checkoutSummary" /> */}
             <Button btnType="Success" clicked={this.props.purchContinued} > please CONTINUE to CHECKOUT</Button>
        </Auxiliary>
        );
    }
}


export default OrderSummary;